import { ChannelType } from 'lib/enum/message-channel.enum';
import { MessagingChannel } from 'services/Api/MessagingChannels/types';

type AvailableChannelType = ChannelType.Email | ChannelType.Sms | ChannelType.Whatsapp | ChannelType.WebChat;

export type ConnectChannelType = ChannelType.Email | ChannelType.Sms | ChannelType.Whatsapp | ChannelType.WebChat;

export const CONNECT_CHANNEL_OPTIONS: ConnectChannelType[] = [
    ChannelType.Email,
    ChannelType.Sms,
    ChannelType.Whatsapp,
    ChannelType.WebChat,
];

export type AddChannelType = ChannelType.Sms | ChannelType.Whatsapp;

export const ADD_CHANNEL_OPTIONS: AddChannelType[] = [ChannelType.Sms, ChannelType.Whatsapp];

export const hasWebChatChannel = (channels: MessagingChannel[]): boolean => {
    return channels.some(channel => channel.type === ChannelType.WebChat);
};

export const CHANNEL_TYPE_TO_DISPLAY_LABEL: Record<AvailableChannelType, string> &
    Partial<Record<ChannelType, string>> = {
    [ChannelType.Email]: 'Email',
    [ChannelType.Sms]: 'SMS',
    [ChannelType.Whatsapp]: 'Whatsapp',
    [ChannelType.WebChat]: 'Web Chat',
};

export const checkIfAllChannelsDisabled = (channels: MessagingChannel[]): boolean =>
    channels.length > 0 && channels.every(({ enabled }) => !enabled);

export const getEnabledChannels = (channels: MessagingChannel[]): MessagingChannel[] =>
    channels.filter(channel => channel.enabled);

const isChannelEnabled = (channels: MessagingChannel[], channelType: ChannelType): boolean => {
    return channels.some(channel => channel.type === channelType && channel.enabled);
};

const isChannelExists = (channels: MessagingChannel[], channelType: ChannelType): boolean => {
    return channels.some(channel => channel.type === channelType);
};

const getChannelLabel = (channelType: ChannelType): string => {
    return CHANNEL_TYPE_TO_DISPLAY_LABEL[channelType] ?? channelType;
};

const mapToChannelOptions = <T extends ChannelType>(types: T[]): { value: T; label: string }[] => {
    return types.map(type => ({
        value: type,
        label: getChannelLabel(type),
    }));
};

export const getConnectChannelAvailableOptions = (
    channels: MessagingChannel[],
): {
    value: ConnectChannelType;
    label: string;
}[] => {
    const availableTypes = CONNECT_CHANNEL_OPTIONS.filter(channelType => {
        if (channelType === ChannelType.WebChat) {
            return !isChannelExists(channels, channelType);
        }

        return !isChannelEnabled(channels, channelType);
    });

    return mapToChannelOptions(availableTypes);
};

export const getAddChannelAvailableOptions = (
    channels: MessagingChannel[],
): {
    value: AddChannelType;
    label: string;
}[] => {
    const availableTypes = ADD_CHANNEL_OPTIONS.filter(channelType => {
        return !isChannelEnabled(channels, channelType);
    });

    return mapToChannelOptions(availableTypes);
};
